import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedMainHubPriorityMedias from './viewRelatedMainHubPriorityMedias';

export default {
  title: 'Recommendations',
  attributeName: 'recommendationsEnabled',
  fields: [
    {
      attributeName: 'recommendationsEnabled',
      label: 'Recommendations Enabled',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Enable or disable meta tags for this client.',
      default: true,
    },
     {
      attributeName: 'priorityMedias',
      label: 'Priority Medias',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      configFile: viewRelatedMainHubPriorityMedias,
      default: [],
      helpText: 'Select medias from this app to prioritize them in recommendations.',
    },
  ],
};